import * as React from 'react';
export const IcVr = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.83 6.17A4 4 0 0018 5H6a4 4 0 00-4 4v6a4 4 0 004 4h2.8a1.93 1.93 0 00.94-.24 2 2 0 00.72-.65l.71-1.06a1 1 0 011.66 0l.71 1.06a2 2 0 00.72.65c.288.159.611.241.94.24H18a4 4 0 004-4V9a4 4 0 00-1.17-2.83zM9.41 13.41A2 2 0 018 14a2 2 0 112-2 2 2 0 01-.59 1.41zm8 0A2 2 0 0116 14a2 2 0 112-2 2 2 0 01-.59 1.41z'
      fill='currentColor'
    />
  </svg>
);
